import React from "react";
export default function WorkFlow_2_Icon(fillColor) {
  return (
    <div style={{ marginRight: "8px" }}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="24" height="24" rx="12" fill={fillColor.color} />
        <path
          d="M8.10059 17H14.4854V15.8926H9.80957V15.7832L12.0518 13.4658C13.8359 11.627 14.3213 10.8066 14.3213 9.67871V9.66504C14.3213 8.07227 13.002 6.90332 11.2793 6.90332C9.39258 6.90332 8.03906 8.16113 8.03223 9.91113L8.0459 9.91797L9.22168 9.9248L9.22852 9.91113C9.22852 8.74902 10.0146 7.97656 11.1973 7.97656C12.3594 7.97656 13.0635 8.75586 13.0635 9.79492V9.80859C13.0635 10.6699 12.6943 11.1826 11.4365 12.543L8.10059 16.1523V17Z"
          fill="white"
        />
      </svg>
    </div>
  );
}
